import { Injectable, inject, signal } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth';

const AUTO_LOGOUT_SECONDS = 180;
export const FEDERATED_LOGOUT_SECONDS = 30;
export const OKTA_MIGRATION_STORAGE_KEY_STEP = 'okta-migration-step';
export const OKTA_MIGRATION_STORAGE_KEY_EMAIL = 'okta-migration-email';
export const OKTA_MIGRATION_STORAGE_KEY_EXPIRES_AT =
  'okta-migration-expires-at';

@Injectable({ providedIn: 'root' })
export class OktaMigrationTimerService {
  private readonly authService = inject(AuthService);

  private timer: ReturnType<typeof setInterval> | null = null;

  readonly countdown = signal(AUTO_LOGOUT_SECONDS);

  readonly active = signal(false);

  start(seconds = AUTO_LOGOUT_SECONDS): void {
    if (this.timer !== null) return;

    this.countdown.set(seconds);
    this.active.set(true);

    this.timer = setInterval(() => {
      const remaining = this.countdown() - 1;
      this.countdown.set(remaining);

      if (remaining <= 0) {
        this.cancel();
        this.clearPersistedState();
        this.authService.signOut();
      }
    }, 1000);
  }

  cancel(): void {
    if (this.timer !== null) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.active.set(false);
  }

  signOutNow(): void {
    this.cancel();
    this.clearPersistedState();
    this.authService.signOut();
  }

  private clearPersistedState(): void {
    sessionStorage.removeItem(OKTA_MIGRATION_STORAGE_KEY_STEP);
    sessionStorage.removeItem(OKTA_MIGRATION_STORAGE_KEY_EMAIL);
    sessionStorage.removeItem(OKTA_MIGRATION_STORAGE_KEY_EXPIRES_AT);
  }
}
